import { render } from "./StarNoData.vue?vue&type=template&id=5b3d51ed&scoped=true&ts=true"
import script from "./StarNoData.vue?vue&type=script&lang=ts"
export * from "./StarNoData.vue?vue&type=script&lang=ts"

import "./StarNoData.vue?vue&type=style&index=0&id=5b3d51ed&scoped=true&lang=css"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b3d51ed"]])

export default __exports__